import { render, staticRenderFns } from "./editRefund.vue?vue&type=template&id=5c5bb570&scoped=true"
import script from "./editRefund.vue?vue&type=script&lang=js"
export * from "./editRefund.vue?vue&type=script&lang=js"
import style0 from "./editRefund.vue?vue&type=style&index=0&id=5c5bb570&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5bb570",
  null
  
)

export default component.exports